<template>
  <div>
    <div style="width: 340px;margin: 80px auto auto;">

      <h2 class="container-center" style="font-weight: bold;font-size: 28px;margin-bottom: 32px">
        蜜蜂集团管理后台</h2>

      <div class="space-between-y">
        <div>
          <div class="input-title">登陆用户名/手机号</div>
          <el-input placeholder="请输入登陆用户名" v-model="username"></el-input>
        </div>
        <div>
          <div class="input-title">登陆密码</div>
          <el-input show-password placeholder="请输入登陆密码" v-model="password"></el-input>
        </div>
      </div>

      <div style="text-align: center">
        <el-button style="width: 340px" id="loginBtn" icon="el-icon-caret-right" type="primary"
                   round @click="login()">登录
        </el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {mapMutations} from "vuex";
import {user} from "@/api/user";
import {utils} from "@/util/utils";

export default {
  name: 'Login',

  mounted() {
    document.body.style.setProperty('min-width', '0', 'important');
    document.documentElement.style.setProperty('min-width', '0', 'important');
  },

  data() {
    return {
      username: "",
      password: "",
    };
  },

  methods: {

    async login() {
      let loading = this.$loading({text: "登录中..."});

      user.login(this.username, this.password).then(res => {
        let token = res.data.token;
        let userinfo = res.data.userinfo;
        this.updateUser(userinfo);
        utils.cookie.setCookie("wms_token", token);
        this.$router.push({name: "数据看板"})
      }).finally(() => {
        loading.close();
      })
    },
    ...mapMutations('user', ['updateUser'])
  },

};
</script>

<style scoped>

.input-title {
  font-weight: bold;
  color: #3d3d3d;
}

</style>
